import React, { useEffect, useState } from 'react';
import { debtService } from '@/services/debtService';
import { tenantService, type Inquilino } from '@/services/tenantService';
import Breadcrumbs from '@/components/ui/Breadcrumbs';
import { toast } from 'sonner';

const DelinquentTenantsReport: React.FC = () => {
  const [delinquentTenants, setDelinquentTenants] = useState<Inquilino[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDelinquentTenants = async () => {
      try {
        setLoading(true);
        const allDebts = await debtService.getAllDebts(); // Use getAllDebts
        const today = new Date().toISOString().split('T')[0];

        const delinquentDebtIds = new Set<string>();
        allDebts.forEach(debt => {
          if (!debt.esta_pagada && debt.fecha_vencimiento < today) {
            delinquentDebtIds.add(debt.id_inquilino!);
          }
        });

        const tenants = await tenantService.getTenants();
        const filteredTenants = tenants.filter(tenant => tenant.id_inquilino && delinquentDebtIds.has(tenant.id_inquilino));
        setDelinquentTenants(filteredTenants);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        setError(err.message);
        toast.error("Error al cargar el reporte de inquilinos morosos.");
      } finally {
        setLoading(false);
      }
    };
    fetchDelinquentTenants();
  }, []);

  const breadcrumbs = [
    { label: "Inicio", path: "/dashboard" },
    { label: "Reportes", path: "#" },
    { label: "Inquilinos Morosos", path: "/reports/delinquent-tenants" },
  ];

  if (loading) {
    return <div>Cargando reporte de inquilinos morosos...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <Breadcrumbs items={breadcrumbs} />
      <h1 className="text-2xl font-bold mb-4">Reporte de Inquilinos Morosos</h1>
      {delinquentTenants.length === 0 ? (
        <p>No hay inquilinos morosos actualmente.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {delinquentTenants.map((tenant) => (
            <div key={tenant.id_inquilino} className="border p-4 rounded-lg shadow-sm">
              <h2 className="text-xl font-semibold">{tenant.nombre_completo}</h2>
              <p className="text-gray-600">Email: {tenant.email}</p>
              <p className="text-gray-600">Teléfono: {tenant.telefono}</p>
              {tenant.unidad && tenant.edificio_unidad && (
                <p className="text-gray-600">Edificio: {tenant.edificio_unidad.nombre_edificio} - Unidad: {tenant.unidad.numero_unidad}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DelinquentTenantsReport;
